var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mro5a",
    d: "M400.31 371.045a2.288 2.288 0 0 0-3.238 0l-1.78 1.78c-1.49 1.49-6.624-.146-10.798-4.32-4.173-4.175-5.809-9.307-4.318-10.797l1.78-1.779a2.291 2.291 0 0 0 0-3.239l-7.02-7.019a2.29 2.29 0 0 0-3.239 0l-2.049 2.05c-4.322 4.322.148 15.803 9.988 25.643s21.321 14.312 25.644 9.987l2.048-2.049a2.288 2.288 0 0 0 0-3.238l-7.018-7.019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mro5b",
    d: "M410 362c0-10.493-8.507-19-19-19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mro5c",
    d: "M404 362c0-7.18-5.82-13-13-13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mro5d",
    d: "M398 363a8 8 0 0 0-8-8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-367 -342)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#mro5a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#mro5b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#mro5c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#mro5d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlue);
export default __webpack_public_path__ + "static/media/phone-blue.4d13be75260624570e3f3b58a151bb4e.svg";
export { ForwardRef as ReactComponent };